import React, { useState } from "react";
import classNames from "classnames";

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import styles from "./styles.module.scss";
import ChargesItemRow from "./ChargesItemRow";
import { useGetCollectPaymentContext } from "../../context";
import {
  autoSelectLumpSumItems,
  isInstallmentSelected,
  isPaidItem,
  isUnpaid,
  disableForCentralizedAdmission,
  isSeatBookingEnabled,
  autoSelectSeatBookingItems,
  isEnachEnabled,
  isChequeEnabled
} from "../../utils";

export const TableRows = ({
  rows = [],
  disable,
  type,
  updateCheckedItems,
  showCancelsPaymentDetails,
}) => {
  const [expandedItems, setExpandedItems] = useState({});

  const {
    selectedIndexMapCharges,
    setSelectedIndexMapCharges,
    studentBasicDetails,
    setAlertPopup,
    forCentralizedAdmission
  } = useGetCollectPaymentContext();

  const toggleExpand = (index) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  // Helper to check if a row or child should be marked based on the unpaid status

  const updateLumpSumAutoSelect = (flag, updatedMapIndex) => {
    autoSelectLumpSumItems(
      flag,
      updatedMapIndex,
      rows,
      setSelectedIndexMapCharges
    );
  };
    const updateSeatBookingAutoSelect = (flag, updatedMapIndex) => {
    autoSelectSeatBookingItems(
      flag,
      updatedMapIndex,
      rows,
      setSelectedIndexMapCharges
    );
  };

  // Helper to handle Auto Select functionality
  const handleAutoSelect = (index, isChecked, updatedCheckedItems, rowItem) => {
    const isAutoSelect = rowItem.isAutoSelect;
    if (
      Boolean(studentBasicDetails.lumpSumType) &&
      isInstallmentSelected(rowItem) &&
      isAutoSelect
    ) {
      updateLumpSumAutoSelect(isChecked, updatedCheckedItems);
      if (
        isChecked &&
        studentBasicDetails?.popUpMessageList?.length > 0 &&
        isAutoSelect
      ) {
        setAlertPopup({
          isOpen: true,
          ...studentBasicDetails?.popUpMessageList[0],
        });
      }
    }
    else if((isSeatBookingEnabled(studentBasicDetails) || isEnachEnabled(studentBasicDetails) || isChequeEnabled(studentBasicDetails))&&isAutoSelect){
      updateSeatBookingAutoSelect(isChecked, updatedCheckedItems)
    }
  };

  // Helper to update the checkbox states for parents and children
  // Helper to update the checkbox states for parents and children, including preceding parents and children
  const updateCheckedState = (
    parentIndex,
    childIndex,
    prevState,
    isCurrentlyChecked,
    rows
  ) => {
    const newCheckedItems = { ...prevState[type] };

    // Helper function to check if a row or child should be marked based on its status

    if (childIndex !== undefined) {
      // Case when a child is checked/unchecked
      newCheckedItems[`${parentIndex}-${childIndex}`] = isCurrentlyChecked;

      if (isCurrentlyChecked) {
        // Mark all preceding children (if unpaid)
        for (let i = 0; i <= childIndex; i++) {
          if (isUnpaid(rows[parentIndex].itemTypeWiseInstallmentsList[i])) {
            newCheckedItems[`${parentIndex}-${i}`] = true;
          }
        }

        // Mark the parent if all its children are checked
        const allChildrenChecked = rows[
          parentIndex
        ].itemTypeWiseInstallmentsList.every(
          (_, idx) => newCheckedItems[`${parentIndex}-${idx}`]
        );
        if (allChildrenChecked && isUnpaid(rows[parentIndex])) {
          newCheckedItems[parentIndex] = true;
        }

        // Mark preceding parents and their children (if unpaid)
        for (let i = 0; i < parentIndex; i++) {
          if (isUnpaid(rows[i])) {
            newCheckedItems[i] = true;
            if (rows[i].itemTypeWiseInstallmentsList) {
              rows[i].itemTypeWiseInstallmentsList.forEach((_, childIdx) => {
                if (isUnpaid(rows[i].itemTypeWiseInstallmentsList[childIdx])) {
                  newCheckedItems[`${i}-${childIdx}`] = true;
                }
              });
            }
          }
        }
      } else {
        // Uncheck the current child and subsequent children
        for (
          let i = childIndex;
          i < rows[parentIndex].itemTypeWiseInstallmentsList.length;
          i++
        ) {
          if (isUnpaid(rows[parentIndex].itemTypeWiseInstallmentsList[i])) {
            newCheckedItems[`${parentIndex}-${i}`] = false;
          }
        }

        // Uncheck the parent if no children are checked
        const isAnyChildChecked = rows[
          parentIndex
        ].itemTypeWiseInstallmentsList.some(
          (_, idx) => newCheckedItems[`${parentIndex}-${idx}`]
        );
        if (!isAnyChildChecked && isUnpaid(rows[parentIndex])) {
          newCheckedItems[parentIndex] = false;
        }

        // Uncheck all subsequent parents and their children
        for (let i = parentIndex + 1; i < rows.length; i++) {
          if (isUnpaid(rows[i])) {
            newCheckedItems[i] = false;
            if (rows[i].itemTypeWiseInstallmentsList) {
              rows[i].itemTypeWiseInstallmentsList.forEach((_, childIdx) => {
                if (isUnpaid(rows[i].itemTypeWiseInstallmentsList[childIdx])) {
                  newCheckedItems[`${i}-${childIdx}`] = false;
                }
              });
            }
          }
        }
      }
    } else {
      // Case when the parent is checked/unchecked
      
      const isItemSecurityCharge = rows[parentIndex].description === "Security Deposit"
      newCheckedItems[parentIndex] = isCurrentlyChecked;
      if(isItemSecurityCharge) return newCheckedItems

      if (isCurrentlyChecked) {
        // Mark all its children (if unpaid)
        if (rows[parentIndex].itemTypeWiseInstallmentsList) {
          rows[parentIndex].itemTypeWiseInstallmentsList.forEach(
            (_, childIdx) => {
              if (
                isUnpaid(
                  rows[parentIndex].itemTypeWiseInstallmentsList[childIdx]
                )
              ) {
                newCheckedItems[`${parentIndex}-${childIdx}`] = true;
              }
            }
          );
        }
        if(type !=="OTHER_CHARGES")
        // Mark preceding parents and their children (if unpaid)
        for (let i = 0; i < parentIndex; i++) {
          if (isUnpaid(rows[i])) {
            newCheckedItems[i] = true;
            if (rows[i].itemTypeWiseInstallmentsList) {
              rows[i].itemTypeWiseInstallmentsList.forEach((_, childIdx) => {
                if (isUnpaid(rows[i].itemTypeWiseInstallmentsList[childIdx])) {
                  newCheckedItems[`${i}-${childIdx}`] = true;
                }
              });
            }
          }
        }
      } else {
        // Uncheck the parent and all its children
        if (rows[parentIndex].itemTypeWiseInstallmentsList) {
          rows[parentIndex].itemTypeWiseInstallmentsList.forEach(
            (_, childIdx) => {
              newCheckedItems[`${parentIndex}-${childIdx}`] = false;
            }
          );
        }
        if(type !=="OTHER_CHARGES")
        // Uncheck all subsequent parents and their children
        for (let i = parentIndex + 1; i < rows.length; i++) {
          if (isUnpaid(rows[i])) {
            newCheckedItems[i] = false;
            if (rows[i].itemTypeWiseInstallmentsList) {
              rows[i].itemTypeWiseInstallmentsList.forEach((_, childIdx) => {
                newCheckedItems[`${i}-${childIdx}`] = false;
              });
            }
          }
        }
      }
    }

    return newCheckedItems;
  };

  // handleParentCheckboxChange
  const handleParentCheckboxChange = (index) => {
    setSelectedIndexMapCharges((prevState) => {
      const isChecked = !prevState[type]?.[index];
      const updatedCheckedItems = updateCheckedState(
        index,
        undefined,
        prevState,
        isChecked,
        rows
      );
      handleAutoSelect(index, isChecked, updatedCheckedItems, rows[index]);
      return { ...prevState, [type]: updatedCheckedItems };
    });
  };

  // handleChildCheckboxChange
  const handleChildCheckboxChange = (parentIndex, childIndex) => {
    setSelectedIndexMapCharges((prevState) => {
      const isCurrentlyChecked =
        !prevState[type]?.[`${parentIndex}-${childIndex}`];
      const updatedCheckedItems = updateCheckedState(
        parentIndex,
        childIndex,
        prevState,
        isCurrentlyChecked,
        rows
      );
      handleAutoSelect(
        childIndex,
        isCurrentlyChecked,
        updatedCheckedItems,
        rows[parentIndex].itemTypeWiseInstallmentsList[childIndex]
      );

      return { ...prevState, [type]: updatedCheckedItems };
    });
  };

  return rows.map((row, index) => {
    // Determine if the current row is checked
    const isChecked =
      (selectedIndexMapCharges[type] &&
        !!selectedIndexMapCharges[type][index]) ||
      false;

    return (
      <React.Fragment key={`${row.description}-${index}`}>
        <div
          className={classNames(styles["table-list"], {
            ["text-bold"]: isChecked || row?.failedChequeHistory,
            ["text-dark"]: isChecked || row?.failedChequeHistory,
          })}
        >
          <ChargesItemRow
            checked={isChecked}
            onChange={() => handleParentCheckboxChange(index)}
            row={row}
            disable={disable || isPaidItem(row) || (forCentralizedAdmission && disableForCentralizedAdmission(row)) || (isSeatBookingEnabled(studentBasicDetails) || isEnachEnabled(studentBasicDetails) || isChequeEnabled(studentBasicDetails))&&row?.isAutoSelect}
            isParent={true}
            showCancelsPaymentDetails={showCancelsPaymentDetails}
            type={type}
            desc =  {row?.description}
          />
          <div>
            {row.itemTypeWiseInstallmentsList && (
              <span onClick={() => toggleExpand(index)}>
                {expandedItems[index] ? (
                  <span className="cursor">
                    {" "}
                    <MdKeyboardArrowUp size={26} />
                  </span>
                ) : (
                  <span className="cursor">
                    {" "}
                    <MdKeyboardArrowDown size={26} />
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
        {expandedItems[index] && row.itemTypeWiseInstallmentsList && (
          <div className={styles["installment-parent-container"]}>
            {row.itemTypeWiseInstallmentsList.map((child, childIndex) => {
              // Determine if the child is checked
              const isChildChecked =
                !!selectedIndexMapCharges[type][`${index}-${childIndex}`];

              return (
                <div
                  className={classNames(
                    styles["table-list"],
                    styles["instalment-inner-table"],
                    {
                      ["text-bold"]: isChildChecked,
                      ["text-dark"]: isChildChecked,
                    }
                  )}
                  key={`REGULAR -${row.itemType} - ${index}-${childIndex}`}
                >
                  <ChargesItemRow
                    disable={isPaidItem(child) || disable || isChequeEnabled(studentBasicDetails)&&row?.isAutoSelect}
                    checked={isChildChecked}
                    onChange={() =>
                      handleChildCheckboxChange(index, childIndex)
                    }
                    showCancelsPaymentDetails={showCancelsPaymentDetails}
                    isChildren={true}
                    row={child}
                    type = {type}
                  />
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  });
};
